import React from 'react'
import { CircularProgress } from '@mui/material'

export default function Loading(props) {
  const { message, styles, colorLoading } = props;

  return (
    <div className='loadingWrap' style={{...styles }}>
      <CircularProgress sx={{color: colorLoading }}  />
      {message && <h2 style={{  fontSize: '1.3rem' }}>{message}</h2>}
    </div>
  )
}